<template>
  <div class="box">
    <div class="col-12 box-header">Riepilogo utente:</div>
    <div class="text-justify px-4">
      <label>Nominativo:</label>
      <b> {{userInfo.nome}} {{userInfo.cognome}}</b>
      <br>
      <label>Codice Fiscale:</label>
      <b> {{userInfo.codiceFiscale}}</b>
      <br>
      <label>Data nascita:</label>
      <b> {{dataNascita}}</b>

      <!-- <br>
      <label>Tipo utente:</label>
      <b> {{ }}</b> -->

      <br>
      <label>Accesso:</label>
      <!-- <b> {{ userInfo.logonMode }} {{userInfo.landingOnly === 'limitato' ? ' (' + 'limitato)' : '' }} </b> -->
      <b> {{ userInfo._type_ }} </b>
    </div>

    <div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import 'numeral/locales'
import jp from 'jsonpath'

import moment from 'moment-timezone'

const formatValidData = (value, strFormat) => {
  let retValue = ''

  strFormat = strFormat || 'DD/MM/YYYY'
  if (moment(value, 'YYYY-MM-DD', false).isValid()) {
    // retValue = moment(value, 'YYYY-MM-DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else if (moment(value, 'YYYY/MM/DD', false).isValid()) {
    // retValue = moment(value, 'YYYY/MM/DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else {
    // retValue = moment(value, 'DD/MM/YYYY', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  }

  // console.log('Data in format', value, retValue, moment(value).locale('it').tz('Europe/Rome').format('DD MMMM YYYY HH:mm'))
  return value ? (moment(retValue, strFormat).isValid() ? retValue : '__/__/____') : '__/__/____'
}

export default {
  name: 'UserInfo',
  props: {
    user: { type: Object, required: true },
    incaricato: { type: Object }
  },
  computed: {
    userInfo () {
      let retValue = this.user
      if (Object.keys(this.incaricato).length) retValue = this.incaricato
      if (!retValue._type_) retValue._type_ = this.user._type_
      return retValue
    },
    dataNascita () {
      return formatValidData(this.userInfo.dateOfBirth, 'DD/MM/YYYY')
    },
    isPrecompilato () {
      let p = jp.query(this.modello, '$..precompilato', 1)
      return !!p.length
    },
    numeral () {
      return numeral
    }
  },
  methods: {
    remove () {
      this.$emit('remove')
    },
    onInput (cell) {
      if (cell.importo) {
        let v = parseInt(cell.importo)
        if (v < 0) cell.importo = -v
      }
      this.$emit('input', { modello: this.modello, cell })
    },
    formatValuta (value, event) {
      numeral.locale('it')
      // console.log('value.toLocaleString()',value.toLocaleString('it-IT'), numeral(value).format())
      // return value.toLocaleString('it-IT')
      return numeral(value).format()

      // return value
    }
  }
}
</script>

<style lang="stylus" scoped>
.flat {
  border: 0 !important;
}
</style>
